<template>
  <div :class="['hs-tab', source === 'scale' ? 'hs-tab-scale' : '', className ]" :style="{height: height}">
    <div
      class="item"
      :type="language"
      :class="{'item-active': currentIndex === index, 'item-scale': source === 'scale'}"
      :style="_getItemStyle(index)"
      v-for="(item, index) in options" :key="index"
      @click="_select(index)" v-html="item"></div>
    <div :class="{'slider-bar': true, 'scale': source === 'scale'}" :style="_getSliderBarStyle()">
      <span :style="isTheme ? {'background': getTheme('home:hs-tab:active-color')} : ''"></span>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    options: {
      type: Array,
      default: function() {
        return []
      },
      required: true
    },
    selectedIndex: {
      type: Number,
      default: 0
    },
    height: {
      type: String,
      default: '40px'
    },
    selectedColor: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    source: {
      type: String,
      default: ''
    },
    isTheme: { // 是否显示主题颜色
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentIndex: this.selectedIndex
    }
  },
  watch: {
    selectedIndex(val) {
      this.currentIndex = val
    }
  },
  methods: {
    _select(index) {
      this.currentIndex = index
      this.$emit('select', index)
    },
    _getItemStyle(index) {
      let {options} = this
      return {'width': `${100 / options.length}%`}
    },
    _getSliderBarStyle(index) {
      let { currentIndex, options } = this
      return {width: `${100 / options.length}%`, transform: `translateX(${100 * currentIndex}%)`}
    }
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.hs-tab
  @extend .flex-row
  @extend .flex-between
  width 100%
  position relative
  background-color $color_white
  overflow auto
  &.hs-tab-scale
    background none
  >.item
    @extend .flex-center
    @extend .no-wrap
    height 100%
    font-size 1rem
    color $color_black_text_0
    padding 0 5px
    text-align center
    white-space normal
  >.item[type="EN"],>.item[type="JAP"]
    font-size 0.8rem
  >.item-scale
    font-size 1rem
    color $color_font_gray_1
    align-items center
  >.item-active
    color $color_theme_300
    &.item-scale
      color $color_font_black
      >>> p
        font-weight bold
  >.slider-bar
    position absolute
    left 0
    bottom 0
    height 2px
    background-color $color_theme
    transition all 300ms
    &.scale
      background-color transparent
      height 3px
      >span
        position absolute
        background $color_background_liner_theme
        top 0
        left 50%
        transform translateX(-50%)
        width 20px
        height 3px
        border-radius 1.5px
.hs-tab.hs-tab-scale-color
    background $color_white
    >.item
      color $color_font_black_2
/** 火车票车次列表 直达中转 切换 tab样式修改 */
.hs-tab.train-list
  background $color_white
  >.item
    color $color_font_black_2
    font-size 15px
  >.item-active
    color $color_theme_300
    &.item-scale
      color $color_theme_300
.hs-tab.hs-tab-new{
  >.item{
    @extend .hs-font-body;
    color: $color_black_100;
    padding: 0 4px;
    &.item-active{
      font-weight: 500;
      color: $color_theme_300;
    }
  }
  >.item[type="EN"],>.item[type="JAP"]{
    font-size: 0.8rem;
  }
  >.slider-bar{
    height: 2px;
    border-radius: 1px;
  }
}
</style>
